(function () {
    'use strict';

    angular
        .module('app.campaignAdvertiserManagePageAddInfluencers', [])
        .controller('campaignAdvertiserManagePageAddInfluencersCtrl', ['$scope', '$rootScope', '$modal', '$sanitize',
            'campaignAdvertiserManagePageAddInfluencersService', '$http', '$modalInstance', 'CampaignFormService',
            function ($scope, $rootScope, $modal, $sanitize, campaignAdvertiserManagePageAddInfluencersService, $http, $modalInstance, campaignFormService) {
                $scope.influencerList = [];
                $scope.dataChanged = false;
                $scope.totalInfluencers = 0;

                $scope.removeInfluencer = function (index) {
                    if ($scope.influencerList[index].action === 'add') {
                        $scope.influencerList.splice(index, 1);
                    } else {
                        $scope.influencerList[index].action = 'delete';
                    }

                    $scope.dataChanged = true;
                    $scope.totalInfluencers -= 1;
                }

                $scope.availableTags = function (val) {
                    return campaignAdvertiserManagePageAddInfluencersService.searchInfluencerForCampaign(val, true)
                        .then(function (response) {
                            var availableInfluencers = [];

                            for (var i = 0; i < response.influencer_list.length; i++) {
                                var item = response.influencer_list[i];

                                if ($scope.isInfluencerAdded(item.id)){
                                    if (response.influencer_list.length == 1 && val == item.domain){
                                        $rootScope.handleRequestError({message: val + ' was already added.'}, $scope);
                                    }
                                }
                                else {
                                    availableInfluencers.push({ id: item.id, domain: item.domain, profile_image: item.profile_image, influencer_id: item.influencerId });
                                }
                            }
                            return availableInfluencers;

                        }, function (response) {
                            $rootScope.handleRequestError(response, $scope);
                        });
                };

                $scope.isInfluencerAdded = function(id){
                    for (var i = 0; i < $scope.influencerList.length; i++){
                        var influencer = $scope.influencerList[i];
                        if (influencer.action != 'delete' && influencer.influencer_id == id){
                            return true;
                        }
                    }
                    return false;
                }

                $scope.afterSelectTag = function (item) {
                    if (item != null) {
                        if ($scope.influencerStatus === undefined) {
                            item.status = '';
                        } else {
                            item.status = $scope.influencerStatus ? 'accepted' : '';
                        }
                    }

                    var newItem = {
                        influencer_id: item.id,
                        action: 'add',
                        domain: item.domain,
                        profile_image: item.profile_image,
                        status: item.status
                    }

                    if ($scope.influencerList.length != 0) {
                        var currentBlogIds = $scope.influencerList.map(function (row) {
                            return row.id;
                        });
                        if (currentBlogIds.indexOf(item.id) === -1) {
                            $scope.influencerList.push(newItem);
                        } else {
                            $(".modal-dialog .modal-content").effect("shake")
                        }
                    } else {
                        $scope.influencerList.push(newItem);
                    }

                    $scope.dataChanged = true;
                    $scope.totalInfluencers += 1;
                    $scope.influencerStatus = false;
                    $scope.selectedTag = "";
                }

                $scope.saveInfluencerToCampaign = function () {
                    if ($scope.dataChanged !== true) {
                        return $scope.closeModal();
                    }

                    var changedInfluencers = _.filter($scope.influencerList, function (item) {
                        return item.action === 'add' || item.action === 'delete';
                    });

                    var saveInfluencerToCampaignData = {
                        campaign_id: $scope.campaign_id_add_influencer,
                        influencers: changedInfluencers
                    }

                    campaignAdvertiserManagePageAddInfluencersService.saveInfluencerToCampaign(saveInfluencerToCampaignData, true)
                        .then(function (response) {
                            $scope.closeModal();
                        }, function (response) {
                            $rootScope.handleRequestError(response, $scope);
                        });
                }

                $scope.closeModal = function () {
                    $modalInstance.close();
                }

                function loadCampaignInfluencers(campaignId) {
                    campaignFormService.getCampaignInfluencers(campaignId, false) // loader = false
                        .then(function (res) {
                            var campaignInfluencers = res.data;

                            campaignInfluencers.forEach(function (campaignInfluencer) {
                                $scope.influencerList.push({
                                    id: campaignInfluencer.id,
                                    influencer_id: campaignInfluencer.influencerId,
                                    domain: campaignInfluencer.influencer.domain,
                                    profile_image: campaignInfluencer.influencer.profile_image,
                                    status: campaignInfluencer.status
                                });
                            });

                            $scope.totalInfluencers = $scope.influencerList.length;
                        }, function (errResponse) {
                            $rootScope.handleRequestError(errResponse, $scope);
                        });
                }

                if (!$scope.campaign_id_add_influencer) {
                    $scope.closeModal();
                } else {
                    loadCampaignInfluencers($scope.campaign_id_add_influencer);
                }
            }
        ])
})();